import { ReactElement } from 'react';
import { EditOutlined } from '@ant-design/icons';
import { styled } from 'styled-components';

const Button = styled.span`
  cursor: pointer;
  color: #1890ff;
  font-size: 14px;

  &:hover {
    color: #40a9ff;
  }
`;

interface Props {
  onClick: () => void;
  label?: string;
}

const EditButton = ({ onClick, label = '編集' }: Props): ReactElement => {
  return (
    <Button onClick={onClick}>
      <EditOutlined /> {label}
    </Button>
  );
};

export default EditButton;
